export enum Gender {
  Masculine = 'M',
  Feminine = 'F',
}
